import cPreloader from '@/objects/o-preloader/o-preloader.vue'

export default {
  name: 'oButton',

  components: {
    'c-preloader': cPreloader
  },

  props: {
    label: String,
    type: {
      type: String,
      default: 'button'
    },
    icon: String,
    iconPosition: String,
    showPreloader: {
      type: Boolean,
      default: false
    }
  }
};
